import AboutHero from "./components/AboutHero";
import BrandStory from "./components/BrandStory";
import Reputation from "./components/Reputation";
import ContactCTA from "./components/ContactCTA";
import FAQ from "./components/FAQ";
import { StructuredData, generateBreadcrumbLD, generateFAQPageLD, generateWebPageLD } from "@/components/base/StructuredData";

const faqs = [
  {
    q: "黑料吃瓜网的内容来源是什么？",
    a: "我们的内容来源于全网公开的娱乐资讯、社交媒体热点、用户投稿以及专业编辑的整理汇编。所有内容均经过审核团队核实后发布，确保真实性和时效性。",
  },
  {
    q: "黑料吃瓜网是否收费？",
    a: "完全免费！黑料吃瓜网承诺永久免费向所有吃瓜群众开放。我们通过品牌广告合作来维持平台运营，不会向用户收取任何费用。",
  },
  {
    q: "如何向黑料吃瓜网投稿爆料？",
    a: "你可以通过本页面的「商务合作与爆料通道」提交爆料内容，也可以通过官方邮箱 hello@cgiqwhk.cn 发送独家内幕。我们会对每一条投稿进行核实，一经采纳将注明来源并给予相应奖励。",
  },
  {
    q: "如何保证爆料的真实性和隐私安全？",
    a: "我们拥有专业的审核团队对所有投稿内容进行多方交叉验证。同时，我们严格保护投稿人的隐私信息，所有爆料来源均会进行匿名化处理，绝不泄露投稿人身份。",
  },
  {
    q: "如果发现内容侵权，应该如何申诉？",
    a: "如您认为平台上的内容侵犯了您的合法权益，请通过官方邮箱 hello@cgiqwhk.cn 发送侵权通知，我们将在24小时内核实并处理。你也可以通过联系表单提交申诉，我们会在第一时间响应。",
  },
];

export default function AboutPage() {
  const breadcrumbLD = generateBreadcrumbLD([
    { name: "首页", url: "http://cgiqwhk.cn/" },
    { name: "关于我们", url: "http://cgiqwhk.cn/about" },
  ]);

  const faqLD = generateFAQPageLD(faqs);

  const webPageLD = generateWebPageLD(
    "关于我们 - 黑料吃瓜网",
    "http://cgiqwhk.cn/about",
    "了解黑料吃瓜网的品牌故事、团队介绍与联系方式。全网最真实的吃瓜第一线，24小时不打烊的娱乐资讯平台。"
  );

  return (
    <>
      <StructuredData data={breadcrumbLD} />
      <StructuredData data={faqLD} />
      <StructuredData data={webPageLD} />
      <AboutHero />
      <BrandStory />
      <Reputation />
      <ContactCTA />
      <FAQ />
    </>
  );
}